import { commonUtils } from '@/helpers/commonUtils'
import PptPage, { PageHeader } from '../PptPage/PptPage'
import styles from './PptPage2.module.less'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import { SliderModels } from '@/types/slider'

interface Props {
  project: ProjectModels.ProjectDetail
  no: number
  onSliderReady: (slider: SliderModels.Slider, no: number) => void
}

function PptPage2({ project, no, onSliderReady }: Props) {
  // const sliders = useRef<SliderModels.Slider>()
  const BORDER_RADIO = 32
  const BOX_HEIGHT = 142
  const { t } = useTranslation()
  const [basicSlider, setBasicSlider] = useState<SliderModels.Slider>()
  const [pageHeaderElements, setPageHeaderElements] = useState<SliderModels.PPTElement[]>([])
  const [pageRect, setPageRect] = useState<DOMRect>()

  const contentRef = useRef<HTMLSpanElement>(null)
  const no1Ref = useRef<HTMLSpanElement>(null)
  const no1TextRef = useRef<HTMLSpanElement>(null)
  const no1BoxRef = useRef<HTMLDivElement>(null)
  const no1BgRef = useRef<HTMLImageElement>(null)
  const no2Ref = useRef<HTMLSpanElement>(null)
  const no2TextRef = useRef<HTMLSpanElement>(null)
  const no2BoxRef = useRef<HTMLDivElement>(null)
  const no2BgRef = useRef<HTMLImageElement>(null)
  const no3Ref = useRef<HTMLSpanElement>(null)
  const no3TextRef = useRef<HTMLSpanElement>(null)
  const no3BoxRef = useRef<HTMLDivElement>(null)
  const no3BgRef = useRef<HTMLImageElement>(null)
  const no4Ref = useRef<HTMLSpanElement>(null)
  const no4TextRef = useRef<HTMLSpanElement>(null)
  const no4BoxRef = useRef<HTMLDivElement>(null)
  const no4BgRef = useRef<HTMLImageElement>(null)
  const [elements, setElements] = useState<SliderModels.PPTElement[]>([])

  const onPageRender = (slider: SliderModels.Slider, pageRect: DOMRect) => {
    setBasicSlider(slider)
    setPageRect(pageRect)
  }
  const onPageHeaderRender = (elements: SliderModels.PPTElement[]) => {
    setPageHeaderElements(elements)
  }

  useEffect(() => {
    if (
      !contentRef.current ||
      !no1Ref.current ||
      !no1TextRef.current ||
      !no2Ref.current ||
      !no2TextRef.current ||
      !no3Ref.current ||
      !no3TextRef.current ||
      !no4Ref.current ||
      !no4TextRef.current ||
      !no1BoxRef.current ||
      !no2BoxRef.current ||
      !no3BoxRef.current ||
      !no4BoxRef.current ||
      !no1BgRef.current ||
      !no2BgRef.current ||
      !no3BgRef.current ||
      !no4BgRef.current
    ) {
      return
    }
    const contentRect = contentRef.current?.getBoundingClientRect()
    const no1Rect = no1Ref.current?.getBoundingClientRect()
    const no1BoxRect = no1BoxRef.current?.getBoundingClientRect()
    const no1BgRect = no1BgRef.current?.getBoundingClientRect()
    const no1TextRect = no1TextRef.current?.getBoundingClientRect()
    const no2Rect = no2Ref.current?.getBoundingClientRect()
    const no2BoxRect = no2BoxRef.current?.getBoundingClientRect()
    const no2BgRect = no2BgRef.current?.getBoundingClientRect()
    const no2TextRect = no2TextRef.current?.getBoundingClientRect()
    const no3Rect = no3Ref.current?.getBoundingClientRect()
    const no3BoxRect = no3BoxRef.current?.getBoundingClientRect()
    const no3BgRect = no3BgRef.current?.getBoundingClientRect()
    const no3TextRect = no3TextRef.current?.getBoundingClientRect()
    const no4Rect = no4Ref.current?.getBoundingClientRect()
    const no4BoxRect = no4BoxRef.current?.getBoundingClientRect()
    const no4BgRect = no4BgRef.current?.getBoundingClientRect()
    const no4TextRect = no4TextRef.current?.getBoundingClientRect()

    function genertateBoxElement(
      boxRect: DOMRect,
      noBgRect: DOMRect,
      noRect: DOMRect,
      noTextRect: DOMRect,
      noHTML: string,
      noTextHTML: string
    ): SliderModels.PPTElement[] {
      const SHAPE_RATIO = BORDER_RADIO / BOX_HEIGHT + 0.1
      // 因为各个方块的大小高度其实是一致的，所以这里统一设置
      const SHAPE_WIDTH = boxRect.width
      const SHAPE_HEIGHT = boxRect.height
      const SHAPE_HEIGHT_RATIO = SHAPE_HEIGHT * SHAPE_RATIO
      const SHAPE_WIDTH_DELTA = SHAPE_WIDTH - SHAPE_HEIGHT_RATIO
      const SHAPE_HEIGHT_DELTA = SHAPE_HEIGHT - SHAPE_HEIGHT_RATIO

      return [
        {
          type: 'shape',
          x: boxRect.x,
          y: boxRect.y,
          width: boxRect.width,
          height: boxRect.height,
          viewBox: [boxRect.width, boxRect.height],
          path: `M ${SHAPE_HEIGHT_RATIO} 0 L ${SHAPE_WIDTH_DELTA} 0 Q ${SHAPE_WIDTH} 0 ${SHAPE_WIDTH} ${SHAPE_HEIGHT_RATIO} L ${SHAPE_WIDTH} ${SHAPE_HEIGHT_DELTA} Q ${SHAPE_WIDTH} ${SHAPE_HEIGHT} ${SHAPE_WIDTH_DELTA} ${SHAPE_HEIGHT} L ${SHAPE_HEIGHT_RATIO} ${SHAPE_HEIGHT} Q 0 ${SHAPE_HEIGHT} 0 ${SHAPE_HEIGHT_DELTA} L 0 ${SHAPE_HEIGHT_RATIO} Q 0 0 ${SHAPE_HEIGHT_RATIO} 0 Z`,
          fill: 'rgba(255, 255, 255,1)',
          fixedRatio: false,
          rotate: 0,
          opacity: 0.6,
          pathFormula: SliderModels.ShapePathFormulasKeys.ROUND_RECT,
          keypoints: [SHAPE_RATIO],
          outline: {
            width: 1,
            color: '#A4A3B7',
            style: 'solid',
          },
        },
        {
          type: 'image',
          x: noBgRect.x,
          y: noBgRect.y,
          width: noBgRect.width,
          height: noBgRect.height,
          src: commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png'),
        },
        {
          type: 'text',
          content: noHTML,
          x: noRect.x,
          y: noRect.y - 65,
          width: noRect.width,
          height: noRect.height,
        },
        {
          type: 'text',
          content: noTextHTML,
          x: noTextRect.x,
          y: noTextRect.y - 50,
          width: noTextRect.width,
          height: noTextRect.height,
        },
      ]
    }

    const elements: SliderModels.PPTElement[] = [
      {
        type: 'text',
        content: contentRef.current.outerHTML,
        x: contentRect.x,
        y: contentRect.y,
        width: contentRect.width,
        height: contentRect.height,
      },
      ...genertateBoxElement(
        no1BoxRect,
        no1BgRect,
        no1Rect,
        no1TextRect,
        no1Ref.current.outerHTML,
        no1TextRef.current.outerHTML
      ),

      ...genertateBoxElement(
        no2BoxRect,
        no2BgRect,
        no2Rect,
        no2TextRect,
        no2Ref.current.outerHTML,
        no2TextRef.current.outerHTML
      ),
      ...genertateBoxElement(
        no3BoxRect,
        no3BgRect,
        no3Rect,
        no3TextRect,
        no3Ref.current.outerHTML,
        no3TextRef.current.outerHTML
      ),
      ...genertateBoxElement(
        no4BoxRect,
        no4BgRect,
        no4Rect,
        no4TextRect,
        no4Ref.current.outerHTML,
        no4TextRef.current.outerHTML
      ),
    ]
    setElements(elements)
  }, [])

  useEffect(() => {
    if (!pageRect || !basicSlider || pageHeaderElements.length === 0 || elements.length === 0) {
      return
    }
    const _pageHeaderElements = pageHeaderElements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })
    const _elements = elements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })

    const slider: SliderModels.Slider = {
      ...basicSlider,
      elements: [..._pageHeaderElements, ...basicSlider.elements, ..._elements],
    }
    onSliderReady(slider, no)
  }, [pageRect, basicSlider, pageHeaderElements, elements])

  return (
    <PptPage
      no={no}
      bgSrc={commonUtils.getImagePath('PPTDownload/bg-2.jpg')}
      onPageRender={onPageRender}
    >
      <div className={styles.pptPage2}>
        <PageHeader project={project} onRender={onPageHeaderRender} />
        <span
          className={styles.title}
          style={{ fontWeight: 'bold', fontSize: 64, color: '#2A2C3F' }}
          ref={contentRef}
        >
          {t('dashboard.pdf.content')}
        </span>
        <div className={styles.contentWrap}>
          <div className={styles.content}>
            <div
              className={styles.contentItem}
              ref={no1BoxRef}
              style={{ height: BOX_HEIGHT, borderRadius: BORDER_RADIO }}
            >
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  ref={no1BgRef}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <span
                  className={styles.text}
                  ref={no1Ref}
                  style={{ fontSize: 56, color: '#FFFFFF', fontWeight: 'bold' }}
                >
                  01
                </span>
              </div>
              <span
                className={styles.right}
                ref={no1TextRef}
                style={{ fontSize: 40, color: '#2A2C3F', fontWeight: 'bold' }}
              >
                {t('dashboard.projectDetailPage.basicInformation')}
              </span>
            </div>

            <div
              className={styles.contentItem}
              ref={no2BoxRef}
              style={{ height: BOX_HEIGHT, borderRadius: BORDER_RADIO }}
            >
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  ref={no2BgRef}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <span
                  className={styles.text}
                  ref={no2Ref}
                  style={{ fontSize: 56, color: '#FFFFFF', fontWeight: 'bold' }}
                >
                  02
                </span>
              </div>
              <span
                className={styles.right}
                ref={no2TextRef}
                style={{ fontSize: 40, color: '#2A2C3F', fontWeight: 'bold' }}
              >
                {t('dashboard.projectDetailPage.primaryAnalysis')}
              </span>
            </div>

            <div
              className={styles.contentItem}
              ref={no3BoxRef}
              style={{ height: BOX_HEIGHT, borderRadius: BORDER_RADIO }}
            >
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  ref={no3BgRef}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <span
                  className={styles.text}
                  ref={no3Ref}
                  style={{ fontSize: 56, color: '#FFFFFF', fontWeight: 'bold' }}
                >
                  03
                </span>
              </div>

              <span
                className={styles.right}
                ref={no3TextRef}
                style={{ fontSize: 40, color: '#2A2C3F', fontWeight: 'bold' }}
              >
                {t('dashboard.projectDetailPage.detailAnalysis')}
              </span>
            </div>

            <div
              className={styles.contentItem}
              ref={no4BoxRef}
              style={{ height: BOX_HEIGHT, borderRadius: BORDER_RADIO }}
            >
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  ref={no4BgRef}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <span
                  className={styles.text}
                  ref={no4Ref}
                  style={{ fontSize: 56, color: '#FFFFFF', fontWeight: 'bold' }}
                >
                  04
                </span>
              </div>

              <span
                className={styles.right}
                ref={no4TextRef}
                style={{ fontSize: 40, color: '#2A2C3F', fontWeight: 'bold' }}
              >
                {t('dashboard.projectDetailPage.heatmapAnalysis')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </PptPage>
  )
}

export default PptPage2
